
export abstract class ValidateHelper {
    public static formatPhone(phoneNumber: string) {
        return phoneNumber.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    public static isEmail(mail: string): boolean {
        const expression = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return expression.test(mail);
    }
}
